import type { ImageGenParams } from '../types/timeline'

/**
 * 诗云（ShiYun）创作 options：仅透传 ClientUiCatalog 白名单（quality/format/style/aspect_ratio/n）。
 * 响应格式由后端固定 response_format=url，前端不传、用户不可选。
 */
const SHIYUN_PASSTHROUGH_KEYS = ['quality', 'format', 'style', 'aspect_ratio'] as const

/** 写入时间线 params 快照，供 meta 行展示 */
export function snapshotShiYunDisplayParams(
  extraParamValues: Record<string, string>,
): Pick<ImageGenParams, 'quality' | 'format' | 'style' | 'aspect_ratio'> {
  const out: Pick<ImageGenParams, 'quality' | 'format' | 'style' | 'aspect_ratio'> = {}
  for (const key of SHIYUN_PASSTHROUGH_KEYS) {
    const v = extraParamValues[key]?.trim()
    if (v) out[key] = v
  }
  return out
}

export function buildShiYunImageOptions(
  apiSize: string,
  extraParamValues: Record<string, string>,
): Record<string, unknown> {
  const n = Math.min(10, Math.max(1, parseInt(extraParamValues.n ?? '1', 10) || 1))
  const opts: Record<string, unknown> = { size: apiSize, n }
  for (const key of SHIYUN_PASSTHROUGH_KEYS) {
    const v = extraParamValues[key]?.trim()
    if (v) opts[key] = v
  }
  return opts
}
